import {find, remove, assign} from 'lodash'
export default {
    state: {
        globalLoaderCounter: 0,
        initialized: false,
        isSideBarOpen: true,
        loaders: []
    },

    mutations: {
        addLoader(state, name) {
            let loader = find(state.loaders, (item)=>{
                return item.name === name
            })
            if (loader) {
                loader.count++
                return
            }
            state.loaders.push({name, count: 1})
        },
        removeLoader(state, name) {
            let loader = find(state.loaders, (item)=>{
                return item.name === name
            })
            if (!loader) {
                return
            }
            if (loader) {
                loader.count--
            }
            if (loader.count <= 0) {
                state.loaders = remove(state.loaders, (item)=>{
                    return item.name !== name
                })
            }
        },
    },

    getters: {
        isGlobalLoaderActive(state, getters) {
            return getters.isLoaderActive('global')
        },
        isSideBarOpen (state, getters) {
            return state.isSideBarOpen
        },
        isInitialized (state, getters) {
            return state.initialized
        },
        isLoaderActive(state, getters)  {
            return (name) => {
                return !!find(state.loaders, (item) => item.name === name)
            }
        },
    },
    actions: {
        addGlobalLoader(store) {
            store.commit('addLoader', 'global')
        },
        removeGlobalLoader(store) {
            store.commit('removeLoader', 'global')
        },
        addLoader(store, params) {
            store.commit('addLoader', params)
        },
        removeLoader(store, params) {
            store.commit('removeLoader', params)
        },
        toggleSideBar(store) {
            store.state.isSideBarOpen = !store.state.isSideBarOpen
        },
        setInitialized(store, isInit = true) {
            store.state.initialized = isInit
        },
    }
}
